// extracted by mini-css-extract-plugin
export default {"tableScroll":"qBDQq-VbpLGZLGCu6kROQg==","closed":"JUvPrpzivUvkqaYq4TIB+g=="};